import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import DataTable from '../../components/datatable/DataTable';
import { COLUMN_STYLE, getColumnStyle } from '../../components/datatable/util';

import { defaultRejectHandler } from '../../utils/utility';
import {
  acceptProjectInvitation,
  listProjectInvitation,
  rejectProjectInvitation,
} from '../../redux/project_inv/project_inv_actions';
import Constants from '../../config/constants';
import moment from 'moment';

class InvitationListModal extends React.Component {
  constructor(props) {
    super(props);

    this.search = {
      pageSize: Constants.DATA_TABLE_PAGE_SIZE,
      page: null,
      sorted: [{ id: 'created_date', desc: false }],
      filtered: null,
    };

    this.state = {
      isValid: false,
      isDirty: false,
      isSubmittable: false,
    };

    const { t } = props;

    this.columns = [
      {
        Header: () => <b>{t('project')}</b>,
        accessor: 'project_name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('inviter')}</b>,
        accessor: 'inviter_name',
        ...getColumnStyle(COLUMN_STYLE.text),
      },
      {
        Header: () => <b>{t('status')}</b>,
        accessor: 'status',
        ...getColumnStyle(COLUMN_STYLE.text),
        width: 100,
      },
      {
        Header: () => <b>{t('date')}</b>,
        accessor: 'created_date',
        Cell: row => moment(row.value).format('DD-MM-YYYY hh:mm'),
        ...getColumnStyle(COLUMN_STYLE.text),
        width: 160,
      },
    ];
  }

  updateSortFilter(filter, state) {
    if (state) {
      this.search.pageSize = state.pageSize;
      this.search.page = state.page;
      this.search.sorted = state.sorted;
    }
    this.search.filtered = filter;

    this.props.listInvitation(
      this.search.pageSize,
      this.search.page,
      this.search.sorted,
      this.search.filtered,
      this.props.account.id,
    );
  }

  render() {
    const {
      invitations,
      filtered,
      filteredCount,
      isLoading,
      errorMessage,
      t,
      acceptInvitation,
      rejectInvitation,
      ...newProps
    } = this.props;
    return (
      <Modal
        {...newProps}
        backdrop="static"
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('invitation inbox')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {errorMessage ? (
                <div className="alert alert-danger" id="edit-invalid" >{errorMessage}</div>
          ) : null}
          <DataTable
            columns={this.columns}
            data={invitations}
            customActionIcon="fa fa-check"
            onActionCustom={({ original }) => acceptInvitation(original)}
            onActionDelete={({ original }) => rejectInvitation(original)}
            shouldShowActionMenu={(actionName, { original }) => original.status === 'pending'}
            filteredCount={filteredCount}
            isLoading={isLoading}
            onFetchData={state => this.updateSortFilter(filtered, state)}
          />
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, { project }) => ({
  invitations: state.projectInvitation.orderedIds.map(id => state.projectInvitation.objects[id]),
  filteredCount: state.projectInvitation.filteredCount,
  isLoading: state.projectInvitation.isLoading,
  account: state.profile.profile,
  errorMessage: state.projectInvitation.errorMessage,
});

const mapDispatchToProps = (dispatch) => ({
  listInvitation: (pageSize, page, sorted, filtered, invitee_id) =>
    defaultRejectHandler(dispatch(listProjectInvitation(pageSize, page, sorted, filtered, invitee_id, null))),
  acceptInvitation: (invitation) =>
    defaultRejectHandler(dispatch(acceptProjectInvitation(invitation.id))),
  rejectInvitation: (invitation) =>
    defaultRejectHandler(dispatch(rejectProjectInvitation(invitation.id))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(InvitationListModal),
);



// WEBPACK FOOTER //
// ./src/modal/member/InvitationListModal.js